export const toastOptions = {
    className: 'toast-attributes',
    containerClass: 'text-center',
    theme: 'outline',
    position: 'bottom-center',
    duration: 8000,
};
